/**
 * Organisation Domain
 */

export enum Location {
  Chatswood = 'Chatswood',
}

export enum Grade {
  HSC = 'hsc',
  Prelim = 'prelim',
}

export enum Subject {
  Chemistry = 'chem',
  Physics = 'phys',
  MathsExt1 = 'mtx1',
  MathsExt2 = 'mtx2',
}

export enum SubjectLabel {
  Chemistry = 'Chemistry',
  Physics = 'Physics',
  MathsExt1 = 'Maths Ext 1',
  MathsExt2 = 'Maths Ext 2',
}

export enum UserGroup {
  Admins = 'Admins',
  Managers = 'Managers',
  Owners = 'Owners',
  Teachers = 'Teachers',
  Students = 'Students',
}

export enum UserType {
  Student = 'STUDENT',
  Staff = 'STAFF',
}

export enum LeadType {
  Enrolment = 'ENROLMENT',
  Contact = 'CONTACT',
}

export enum EnrolmentMethod {
  Class = 'CLASS',
  Makeup = 'MAKEUP',
  OneOff = 'ONEOFF',
}

/**
 * Xero & Billing
 */

export enum XeroDepartment {
  Chemistry = 'Chemistry',
  Physics = 'Physics',
  Mathematics = 'Mathematics',
}

export enum XeroLineItemCode {
  Meta = 'META',
  SpecialDiscount = 'SD',
}

export enum BillingType {
  Term = 'TERM',
  Extra = 'EXTRA',
}

export enum CreditType {
  Credit = 'CREDIT',
}

/**
 * Application Settings
 */

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

/**
 * Exam Marking (Shared)
 */

export enum LegacyExamAttemptType {
  LegacyExam = 'EXAM',
  Question = 'QUESTION',
}

export enum LegacyExamAttemptStatus {
  MarkingInProgress = 'MARKING_IN_PROGRESS',
  Marked = 'MARKED',
}
